module.exports = __webpack_public_path__ + "static/media/MACS_logo_small.4a41778c.svg";